<div class="container">
  <section>
    <h1>500</h1>
    <h5 class="card-title font-weight-bold">LE SERVEUR NE RÉPOND PAS</h5>
    <p class="card-text">
      Veuillez <a href="https://www.takima.fr/contact">contacter</a> un administrateur en cas d'attente de longue durée.
    </p>
  </section>
</div>
